/**
 * @Description 标签库
 */
import { get, post } from '@/common/request/index';

/**
 * 查询分组列表-标签库-左侧列表接口
 * https://yapi.lanhanba.com/project/532/interface/api/99332
 */
export function labelGroupList(params: any) {
  return get('/labelLib/group/list', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}

/**
 * 按业务类型列表查询分组列表（支持多个业务类型）
 */
export function labelGroupListByTypes(params: any) {
  return get('/labelLib/group/listByTypes', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}

/**
 * 查询分组列表-标签库-右侧内容
 * https://yapi.lanhanba.com/project/532/interface/api/99334
 */
export function labelGroupDetail(params: any) {
  return get('/labelLib/group/detail', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}

/**
 * 查询分组列表-标签库-创建标签分组
 * https://yapi.lanhanba.com/project/532/interface/api/99326
 */
export function createLabelGroup(params: any) {
  return post('/labelLib/group/create', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}

/**
 * 查询分组列表-标签库-删除标签分组
 * https://yapi.lanhanba.com/project/644/interface/api/96980
 */
export function deleteLabelGroup(params: any) {
  return post('/labelLib/group/delete', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}

/**
 * 查询分组列表-标签库-更新标签分组
 * https://yapi.lanhanba.com/project/532/interface/api/99328
 */
export function updateLabelGroup(params: any) {
  return post('/labelLib/group/update', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}

/**
 * 标签库全量数据
 * https://yapi.lanhanba.com/project/532/interface/api/99340
 */
export function getLabelGroupData(params: any) {
  return get('/labelLib/group/listWithLabels', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}

/**
 * 按业务类型列表查询标签分组详情（支持多个业务类型）
 */
export function getLabelGroupDataByTypes(params: any) {
  return get('/labelLib/group/listWithLabelsByTypes', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}


/**
 * 更新加盟商标签
 * https://yapi.lanhanba.com/project/644/interface/api/97028
 */
export function updateFranchiseeLabels(params: any) {
  return post('/standard/franchisee/label/update', params, {
    isMock: false,
    mockId: 644,
    needHint: true,
  });
}
